import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/myportafolio');
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const r = await fetch(`${API}/auth/session`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'X-Session-ID': sessionId, 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error('Auth failed');
        const data = await r.json();
        setUser(data);
        // Clean hash and go to portfolio dashboard
        window.history.replaceState(null, '', '/myportafolio');
        navigate('/myportafolio', { state: { user: data } });
      } catch (e) {
        console.error('Auth callback error:', e);
        navigate('/myportafolio');
      }
    })();
  }, [navigate, setUser]);

  return (
    <div
      className="min-h-screen flex items-center justify-center text-white"
      style={{ backgroundColor: '#020817' }}
      data-testid="auth-callback"
    >
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full border-2 border-[#00f4ff] border-t-transparent animate-spin" />
        <div className="text-[#00f4ff] tracking-[0.3em] text-sm">SIGNING YOU IN…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
